import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _jsxFileName = "/Users/brentvatne/coding/react-native-action-sheet/src/ActionSheet/index.tsx";
import * as React from 'react';
import { Animated, BackHandler, Easing, StyleSheet, TouchableWithoutFeedback, View } from 'react-native';
import ActionGroup from './ActionGroup';
var OPACITY_ANIMATION_IN_TIME = 225;
var OPACITY_ANIMATION_OUT_TIME = 195;
var EASING_OUT = Easing.bezier(0.25, 0.46, 0.45, 0.94);
var EASING_IN = Easing.out(EASING_OUT);

var ActionSheet = function (_React$Component) {
  _inherits(ActionSheet, _React$Component);

  function ActionSheet() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ActionSheet);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ActionSheet)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this._actionSheetHeight = 360;
    _this.state = {
      isVisible: false,
      isAnimating: false,
      options: null,
      onSelect: null,
      overlayOpacity: new Animated.Value(0),
      sheetOpacity: new Animated.Value(0)
    };

    _this._setActionSheetHeight = function (_ref) {
      var nativeEvent = _ref.nativeEvent;
      return _this._actionSheetHeight = nativeEvent.layout.height;
    };

    _this._selectCancelButton = function () {
      var options = _this.state.options;

      if (!options) {
        return false;
      }

      if (typeof options.cancelButtonIndex === 'number') {
        return _this._onSelect(options.cancelButtonIndex);
      } else {
        return _this._animateOut();
      }
    };

    _this._onSelect = function (index) {
      var _this$state = _this.state,
          isAnimating = _this$state.isAnimating,
          onSelect = _this$state.onSelect;

      if (isAnimating) {
        return false;
      }

      onSelect && onSelect(index);
      return _this._animateOut();
    };

    _this._animateOut = function () {
      var _this$state2 = _this.state,
          isAnimating = _this$state2.isAnimating,
          overlayOpacity = _this$state2.overlayOpacity,
          sheetOpacity = _this$state2.sheetOpacity;

      if (isAnimating) {
        return false;
      }

      BackHandler.removeEventListener('actionSheetHardwareBackPress', _this._selectCancelButton);

      _this.setState({
        isAnimating: true
      });

      Animated.parallel([Animated.timing(overlayOpacity, {
        toValue: 0,
        easing: EASING_IN,
        duration: OPACITY_ANIMATION_OUT_TIME,
        useNativeDriver: _this.props.useNativeDriver
      }), Animated.timing(sheetOpacity, {
        toValue: 0,
        easing: EASING_IN,
        duration: OPACITY_ANIMATION_OUT_TIME,
        useNativeDriver: _this.props.useNativeDriver
      })]).start(function (result) {
        if (result.finished) {
          _this.setState({
            isVisible: false,
            isAnimating: false
          });
        }
      });
      return true;
    };

    return _this;
  }

  _createClass(ActionSheet, [{
    key: "render",
    value: function render() {
      var _this$state3 = this.state,
          isVisible = _this$state3.isVisible,
          overlayOpacity = _this$state3.overlayOpacity;
      var overlay = isVisible ? React.createElement(Animated.View, {
        style: [styles.overlay, {
          opacity: overlayOpacity
        }],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54
        }
      }) : null;
      return React.createElement(View, {
        style: {
          flex: 1
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 64
        }
      }, React.Children.only(this.props.children), overlay, isVisible ? this._renderSheet() : null);
    }
  }, {
    key: "_renderSheet",
    value: function _renderSheet() {
      var _this$state4 = this.state,
          options = _this$state4.options,
          isAnimating = _this$state4.isAnimating,
          sheetOpacity = _this$state4.sheetOpacity;

      if (!options) {
        return null;
      }

      var optionsArray = options.options,
          icons = options.icons,
          tintIcons = options.tintIcons,
          destructiveButtonIndex = options.destructiveButtonIndex,
          textStyle = options.textStyle,
          tintColor = options.tintColor,
          title = options.title,
          titleTextStyle = options.titleTextStyle,
          message = options.message,
          messageTextStyle = options.messageTextStyle,
          showSeparators = options.showSeparators,
          separatorStyle = options.separatorStyle;
      return React.createElement(TouchableWithoutFeedback, {
        onPress: this._selectCancelButton,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 97
        }
      }, React.createElement(Animated.View, {
        needsOffscreenAlphaCompositing: isAnimating,
        style: [styles.sheetContainer, {
          opacity: sheetOpacity,
          transform: [{
            translateY: sheetOpacity.interpolate({
              inputRange: [0, 1],
              outputRange: [this._actionSheetHeight, 0]
            })
          }]
        }],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 98
        }
      }, React.createElement(View, {
        style: styles.sheet,
        onLayout: this._setActionSheetHeight,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 114
        }
      }, React.createElement(ActionGroup, {
        options: optionsArray,
        icons: icons,
        tintIcons: tintIcons === undefined ? true : tintIcons,
        destructiveButtonIndex: destructiveButtonIndex,
        onSelect: this._onSelect,
        startIndex: 0,
        length: optionsArray.length,
        textStyle: textStyle || {},
        tintColor: tintColor,
        title: title || undefined,
        titleTextStyle: titleTextStyle,
        message: message || undefined,
        messageTextStyle: messageTextStyle,
        showSeparators: showSeparators,
        separatorStyle: separatorStyle,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 115
        }
      }))));
    }
  }, {
    key: "showActionSheetWithOptions",
    value: function showActionSheetWithOptions(options, onSelect) {
      var _this2 = this;

      var _this$state5 = this.state,
          isVisible = _this$state5.isVisible,
          overlayOpacity = _this$state5.overlayOpacity,
          sheetOpacity = _this$state5.sheetOpacity;

      if (isVisible) {
        return;
      }

      this.setState({
        options: options,
        onSelect: onSelect,
        isVisible: true,
        isAnimating: true
      });
      overlayOpacity.setValue(0);
      sheetOpacity.setValue(0);
      Animated.parallel([Animated.timing(overlayOpacity, {
        toValue: 0.32,
        easing: EASING_OUT,
        duration: OPACITY_ANIMATION_IN_TIME,
        useNativeDriver: this.props.useNativeDriver
      }), Animated.timing(sheetOpacity, {
        toValue: 1,
        easing: EASING_OUT,
        duration: OPACITY_ANIMATION_IN_TIME,
        useNativeDriver: this.props.useNativeDriver
      })]).start(function (result) {
        if (result.finished) {
          _this2.setState({
            isAnimating: false
          });
        }
      });
      BackHandler.addEventListener('actionSheetHardwareBackPress', this._selectCancelButton);
    }
  }]);

  return ActionSheet;
}(React.Component);

ActionSheet.defaultProps = {
  useNativeDriver: true
};
export { ActionSheet as default };
var styles = StyleSheet.create({
  overlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: 'black'
  },
  sheetContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    backgroundColor: 'transparent',
    alignItems: 'flex-end',
    justifyContent: 'center',
    flexDirection: 'row'
  },
  sheet: {
    flex: 1,
    backgroundColor: 'transparent'
  }
});